import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import styled, { css } from "styled-components";
import { NewButton } from "../button";
import { useModalScroll } from "./hooks/useModalScroll";
import { Modal } from "./Modal";
import { ModalTitle } from "./titles/ModalTitle";
export { DialogModalText, DialogModalTitle } from "./style/Styled";
const _DialogModal = ({ hideCloseButton, resizable, size = "100", maxWidth, title, titleAlign, subtitle, ...props }) => {
    const [fullSize, setFullSize] = useState(false);
    const ref = useRef(null);
    const { isScrollable, scrollWidth } = useModalScroll({
        ref,
        isOpen: props.isOpen,
        footer: props.footer,
        children: props.children,
    });
    return (_jsx(StyledModal, { ...props, size: size, fullSize: fullSize, maxWidth: maxWidth, children: _jsxs(Content, { "$size": size, "$scrollWidth": scrollWidth, "$textAlign": titleAlign, children: [_jsx(Title, { title: title, subtitle: subtitle, titleAlign: titleAlign, fullSize: fullSize, hideCloseButton: hideCloseButton, onClose: props.onClose, onFullSizeClick: () => setFullSize((f) => !f), resizable: resizable, size: size }), _jsx(Children, { ref: ref, children: props.children }), props.footer && (_jsx(_Fragment, { children: _jsx(Footer, { "$isScrollable": isScrollable, children: props.footer }) }))] }) }));
};
const Title = styled(ModalTitle) ``;
const Footer = styled.div `
  ${(p) => css `
    padding-top: ${p.theme.spacing.sp16};

    ${NewButton} + ${NewButton} {
      margin-left: ${p.theme.spacing.sp8};
    }
  `};

  ${({ $isScrollable }) => $isScrollable &&
    css `
      border-top: 1px solid ${(p) => p.theme.systemColors.grey200};
    `}
`;
const Children = styled.div `
  flex: 1;
  position: relative;
  overflow-y: auto;
`;
const StyledModal = styled(Modal) `
  opacity: 0;
`;
const Content = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.sp16};
  background: ${(p) => p.theme.systemColors.white};
  border-radius: 6px;
  position: relative;
  max-width: 100%;
  max-height: 100%;

  ${(p) => {
    const sizes = {
        "50": p.theme.spacing.sp16,
        "100": p.theme.spacing.sp24,
        "200": p.theme.spacing.sp32,
        "400": p.theme.spacing.sp32,
    };
    const size = sizes[p.$size || "100"];
    return p.$size === "50"
        ? css `
          padding-top: ${size};
          padding-bottom: ${size};

          ${Title.Wrapper}, ${Children}, ${Footer} {
            padding-left: ${size};
            padding-right: ${size};
          }
        `
        : css `
          padding-top: ${size};
          padding-bottom: ${size};

          ${Children}, ${Footer} {
            padding-left: ${size};
            padding-right: ${size};
          }

          ${Title.Wrapper} {
            padding-left: ${p.$textAlign === "center" ? p.theme.spacing.sp16 : size};
            padding-right: ${p.theme.spacing.sp16};
          }
        `;
}}
`;
export const DialogModal = Object.assign(_DialogModal, {
    Title,
    Content,
    Footer,
    Children,
});
